export const assessmentApiEndpoint = 'https://us-central1-sustainibleapi.cloudfunctions.net/fetchAssessment';
export const generateCode = (length: number) => {
    var result           = '';
    var characters       = `${Date.now()}ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678`;
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export const assessmentOperatingApiEndpoint = 'https://us-central1-sustainibleapi.cloudfunctions.net/fetchOperatingAssessment';
export const generatOperatingeCode = (length: number) => {
    var result           = '';
    var characters       = `${Date.now()}ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678`;
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

export const assessmentBusinessApiEndpoint = 'https://us-central1-sustainibleapi.cloudfunctions.net/fetchBusinessAssessment';
export const generateBusinessCode = (length: number) => {
    var result           = '';
    var characters       = `${Date.now()}ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345678`;
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}